import { useSyncExternalStore } from 'react';

const subscribe = (query: string) => (callback: () => void) => {
  const mq = globalThis.matchMedia(query);
  mq.addEventListener('change', callback);
  return () => mq.removeEventListener('change', callback);
};

export const useMediaQuery = (query: string) => {
  return useSyncExternalStore(
    subscribe(query),
    () => globalThis.matchMedia(query).matches,
    () => false
  );
};
